import { ProductModel } from '../../organizations/models/product.model';

export class ProfileModel {
  id: number;

  startDate: Date = (() => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  })();

  endDate: Date = (() => {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 10);
    date.setHours(0, 0, 0, 0);
    return date;
  })();

  productId: string;
  product: ProductModel;
  organisationId: string;
  userId?: string = null;
  profilePermissions?: ProfilePermissionModel[] = [];

  static validate(profile: ProfileModel): boolean {
    if (!profile.startDate || !profile.endDate || !profile.productId) {
      return false;
    }

    return true;
  }
}

export interface ProfilePermissionModel {
  profileId: number;
  permissionId: string;
  isSet: boolean;
}
